/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientReassignmentDialog.vue?vue&type=template&id=0d2e0d36&scoped=true"
import script from "./PatientReassignmentDialog.vue?vue&type=script&lang=js"
export * from "./PatientReassignmentDialog.vue?vue&type=script&lang=js"
import style0 from "./PatientReassignmentDialog.vue?vue&type=style&index=0&id=0d2e0d36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2e0d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2e0d36')) {
      api.createRecord('0d2e0d36', component.options)
    } else {
      api.reload('0d2e0d36', component.options)
    }
    module.hot.accept("./PatientReassignmentDialog.vue?vue&type=template&id=0d2e0d36&scoped=true", function () {
      api.rerender('0d2e0d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/PatientReassignmentDialog.vue"
export default component.exports